import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hasErrors, selectRawErrors } from "../selectors/error/ErrorSelector";
import * as ErrorAction from "../stores/error/ErrorAction";

export interface IError {
    code: number;
    message: string;
}

export const useDispatchWithError = (
    actionId: string,
    callback: () => void,
    errorsDefinition?: any
): [(action) => void, IError] => {
    const dispatch = useDispatch();
    const [callFinished, setCallFinished] = useState<boolean>(false);

    const rawError: any = useSelector(state => selectRawErrors(state, [actionId]));
    const hasError: boolean = useSelector(state => hasErrors(state, [actionId]));

    const getErrorText = errorNumber => errorsDefinition?.[errorNumber] || rawError[actionId]?.message;

    useEffect(() => {
        dispatch(ErrorAction.removeByType(actionId));
    }, [dispatch, actionId]);

    useEffect(() => {
        if (!callFinished) return;
        if (callFinished && !hasError) {
            callback();
        }
        if (callFinished) setCallFinished(false);
    }, [callFinished, callback, hasError]);

    const dispatchWithError = action => {
        dispatch(action).then(() => {
            setCallFinished(true);
        });
    };
    const errorStatus = rawError[actionId]?.status;
    const errorText = getErrorText(errorStatus);
    const error: IError = hasError ? { code: errorStatus, message: errorText } : null;

    return [dispatchWithError, error];
};
